(() => {
  if (window.stSizeGuideLoaded) return;
  window.stSizeGuideLoaded = true;

  const carryPreview = (destination) => {
    const current = new URL(window.location.href);
    const previewId = current.searchParams.get('preview_theme_id');
    if (previewId && /^\d+$/.test(previewId)) destination.searchParams.set('preview_theme_id', previewId);
    return destination;
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('[data-st-size-guide-link]');
    if (!link) return;
    const target = carryPreview(new URL(link.href, window.location.origin));
    const form = document.getElementById(link.dataset.productForm);
    const variant = form?.querySelector('[name="id"]')?.value;
    if (variant && /^\d+$/.test(variant)) target.searchParams.set('variant', variant);
    link.href = target.href;
  }, true);

  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-st-size-guide]').forEach((guide) => {
      if (guide.dataset.initialized) return;
      guide.dataset.initialized = 'true';
      guide.querySelectorAll('[data-st-size-return]').forEach((link) => {
        link.href = carryPreview(new URL(link.href, window.location.origin)).href;
      });
      const buttons = guide.querySelectorAll('[data-st-size-unit]');
      const values = guide.querySelectorAll('[data-st-size-value]');
      const labels = guide.querySelectorAll('[data-st-size-unit-label]');
      const status = guide.querySelector('[data-st-size-status]');
      const format = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
      buttons.forEach((button) => button.addEventListener('click', () => {
        const cm = button.dataset.stSizeUnit === 'cm';
        buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        values.forEach((cell) => {
          const value = Number(cm ? cell.dataset.cm : cell.dataset.inches);
          if (Number.isFinite(value)) cell.textContent = format.format(value);
        });
        labels.forEach((label) => { label.textContent = cm ? '(cm)' : '(in)'; });
        if (status) status.textContent = cm ? status.dataset.cmMessage : status.dataset.inchesMessage;
      }));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
